<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="550px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="82vh">
               <v-row>
                  <v-col cols="12">
                     <v-toolbar
                        flat
                        dense
                        :class="$globalstore.toolbar_headerclass"
                     >
                        <v-toolbar-title>
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              <span>Select Staff</span>
                           </template>
                           <template v-else>
                              Staff
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2"
                           >Cancel
                        </v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2"
                           >OK
                        </v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-row no-gutters justify="space-around">
                  <v-col cols="8" md="8">
                     <v-btn
                        block
                        color="primary"
                        class="ma-1"
                        @click="allStaffBtnClick"
                     >
                        All Staff
                     </v-btn>
                  </v-col>
               </v-row>

               <v-row no-gutters>
                  <v-col cols="12" md="12" class="px-2">
                     <v-text-field
                        label="Search"
                        v-model="staffsearch"
                     ></v-text-field>
                     <v-data-table
                        dense
                        v-model="selectedstaff"
                        height="50vh"
                        :headers="staff_header"
                        :items="staffdata"
                        item-key="user_id"
                        fixed-header
                        @click:row="staffRowClick"
                        :single-select="false"
                        :show-select="true"
                        :search="staffsearch"
                     >
                     </v-data-table>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
   </div>
</template>

<script>
   import { RecipientConst } from "@/common/recipientconstant.js";

   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            resolve: null,
            reject: null,
            modal: false,
            rcpttype: RecipientConst.RECIPIENT_TYPE,
            rcptcatglist: RecipientConst.RECIPIENT_CATEGORY,
            rcptgroup: RecipientConst.RECIPIENT_GROUP,
            rcptcode: RecipientConst.RECIPIENT_CODE,
            selectedstaff: [],
            selectedrecipient: [],
            staffdata: [],
            staffsearch: "",

            staff_header: [
               {
                  text: "Name",
                  value: "staff_fullname",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      methods: {
         staffRowClick(item, row) {
            row.select(!row.isSelected);
         },

         open() {
            this.loadStaff();

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         allStaffBtnClick() {
            let grp = this.rcptgroup.find(
               (x) => x.id === this.rcptcode.ALL_STAFF
            );

            let recipient = new Array();

            let rcpt = {
               type: this.rcpttype.STAFF,
               code: this.rcptcode.ALL_STAFF,
               id: this.rcptcode.ALL_STAFF,
               text: grp.text,
               color: grp.color,
            };
            recipient.push(rcpt);

            this.resolve(true);
            this.modal = false;
            this.$emit("return-recipient", recipient);
         },

         OkBtnClick() {
            if (this.selectedstaff.length > 0) {
               let recipient = new Array();
               for (let i = 0; i < this.selectedstaff.length; i++) {
                  var staff = this.selectedstaff[i];
                  var grp = this.rcptgroup.find(
                     (x) => x.id === this.rcptcode.INDIVIDUAL_STAFF
                  );
                  let rcpt = {
                     type: this.rcpttype.STAFF,
                     code: this.rcptcode.INDIVIDUAL_STAFF,
                     id: staff.user_id,
                     text: staff.staff_fullname,
                     color: grp.color,
                  };
                  recipient.push(rcpt);
                  this.resolve(true);
                  this.modal = false;
                  this.$emit("return-recipient", recipient);
               }
            } else {
               this.resolve(false);
               this.modal = false;
            }
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         async loadStaff() {
            await this.$http({
               url: "/common/recipientstaff.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.staffdata = response.data.staffdata;
                  }
               }
            });
         },
      },
   };
</script>
